import { render, staticRenderFns } from "./PDFAnnotations.vue?vue&type=template&id=98f3a066&scoped=true"
import script from "./PDFAnnotations.vue?vue&type=script&lang=js"
export * from "./PDFAnnotations.vue?vue&type=script&lang=js"
import style0 from "./PDFAnnotations.vue?vue&type=style&index=0&id=98f3a066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f3a066",
  null
  
)

export default component.exports